import { render } from "./CAPComponent.vue?vue&type=template&id=2031cc15&scoped=true"
import script from "./CAPComponent.vue?vue&type=script&lang=js"
export * from "./CAPComponent.vue?vue&type=script&lang=js"

import "./CAPComponent.vue?vue&type=style&index=0&id=2031cc15&scoped=true&lang=css"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2031cc15"]])

export default __exports__